import React from 'react';
import PropTypes from 'prop-types';
import { Container, Tab, Tabs, Typography, LinearProgress } from '@mui/material';
import SensorTypeSingleTable from './SensorTypePointTable';
import PointTrendContainer from '../../trends/PointTrendContainer';

import './SensorType.css';

const TABS = ['summary', 'trends'];

const SensorTypeSingleView = ({
  buildingName,
  buildingTz,
  points,
  pointType,
  tab,
  handleTabChange,
}) => {
  const content = (tabName) => {
    switch (tabName) {
      case 'trends': {
        if (!points.length) {
          return <LinearProgress color="secondary" />;
        }
        return (
          <PointTrendContainer
            title={pointType}
            pointIds={points.map((p) => p.id)}
            variant="byType"
          />
        );
      }
      case 'summary':
      default:
        return <SensorTypeSingleTable points={points} buildingTz={buildingTz} />;
    }
  };
  const tabIndex = Math.max(TABS.indexOf(tab), 0);
  return (
    <div className="sensor-type-container">
      <Container>
        <div className="SensorType-summary">
          <Typography>{`Sensor Type: ${pointType}`}</Typography>
          <Typography>{`Building: ${buildingName}`}</Typography>
          <Typography>{`Points: ${points.length}`}</Typography>
        </div>
      </Container>
      <Tabs
        indicatorColor="secondary"
        textColor="inherit"
        value={tabIndex}
        onChange={(e, index) => handleTabChange(TABS[index])}
      >
        <Tab label="Summary" />
        <Tab label="Trends" />
      </Tabs>
      {content(tab)}
    </div>
  );
};

SensorTypeSingleView.propTypes = {
  buildingName: PropTypes.string,
  pointType: PropTypes.string,
};

SensorTypeSingleView.defaultProps = {
  buildingName: 'Loading...',
  pointType: 'Loading...',
};

export default SensorTypeSingleView;
